import { IMyMapsState } from "./interfaces";

export const DEFAULT_MYMAPS: IMyMapsState = {
	rootId: "",
	hasFolders: false,
	alwaysOnMapFoldersCount: 0,
	alwaysOnMapItemsCount: 0,
	openedFolderId: "",
};
